module.exports = __webpack_public_path__ + "img/certificate-5.1fb6911b.png";